import { Directive, InjectionToken, Input } from '@angular/core';
export const SUFFIX_DIRECTIVE: InjectionToken<SuffixDirective> =
  new InjectionToken<SuffixDirective>('SuffixDirective');

@Directive({
  selector: '[lyceoIconSuffix], [lyceoTextSuffix]',
  providers: [{ provide: SUFFIX_DIRECTIVE, useExisting: SuffixDirective }],
  standalone: true,
})
export class SuffixDirective {
  @Input()
  public set lyceoTextSuffix(value: '') {
    this.isText = true;
  }

  public isText: boolean = false;
}
